export default {
  'folding_of_siderails_down': {
    en: 'Folding of Siderails',
    track: 'folding_of_siderails_down'
  },
  'poles_rotation_down': {
    en: 'Poles Rotation',
    track: 'poles_rotation_down'
  },
  'poles_move_up': { track: 'poles_move_up' },
  'poles_move_down': { track: 'poles_move_down' },
  'pushhandles_down': {
    en: 'Push Handles Down',
    track: 'pushhandles_down'
  },
  'mobilift': {
    en: 'Mobilift',
    track: 'mobilift'
  },
  'idrive': {
    en: 'iDrive',
    track: 'idrive'
  },

  'height_adjustment_up': { track: 'height_adjustment_up' },
  'height_adjustment_down': { track: 'height_adjustment_down' },

  'trendelenburg': { track: 'trendelenburg' },
  'trendelenburg_to_max': { track: 'trendelenburg_to_max' },
  'trendelenburg_to_min': { track: 'trendelenburg_to_min' },

  'reversetrendelenburg': { track: 'reversetrendelenburg' },
  'reversetrendelenburg_to_max': { track: 'reversetrendelenburg_to_max' },
  'reversetrendelenburg_to_min': { track: 'reversetrendelenburg_to_min' },

  'backrest30': { track: 'backrest30' },
  'backrest60': { track: 'backrest60' },
  'backrest90': { track: 'backrest90' },

  'calf_rest_adjustment': { track: 'calf_rest_adjustment' },
  'calf_rest_adjustment01': { track: 'calf_rest_adjustment01' },

  'leg_rest_adjustment01': { track: 'leg_rest_adjustment01' },
  'leg_rest_adjustment02': { track: 'leg_rest_adjustment02' },
}
